import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import FaqItem from 'js/pages/LandingPages/components/FaqItem'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import { useMediaQuery } from 'js/pages/LandingPages/hooks/useMediaQuery'
import { lpImages } from 'js/pages/LandingPages/imageSources'
import { SharedSectionProps } from './types'

type Props = {
  title: string
  text: string
  linkText: string
  questions: []
} & SharedSectionProps

const Faq = ({ title, text, linkText, questions }: Props) => {
  const matches = useMediaQuery('(min-width: 1000px)')
  const bgUrl = matches ? lpImages.faqImage.src : lpImages.faqImageMobile.src

  return (
    <section className="pt-56 lg:pt-96">
      <Container>
        <h2 className="quincy mb-32 max-w-[620px] text-32 leading-37 lg:mb-[46px] lg:text-48 lg:leading-52">
          {title}
        </h2>
      </Container>
      <div
        className="mx-auto w-full max-w-1312 bg-right-top bg-no-repeat"
        style={{ backgroundImage: 'url(' + bgUrl + ')' }}
      >
        <div className="px-16 pb-0 lg:pb-[240px]">
          {questions.map(({ answer, question }) => {
            if (!answer || !question) return null

            return (
              <FaqItem key={question} question={question} answer={answer} />
            )
          })}
          <p className="mb-[6px] ml-8 mt-32 text-14 font-demibold leading-19">
            {text}
          </p>
          <a
            href="/"
            className="ml-8 text-14 font-demibold leading-[20px] text-LSPineGreen"
            target="_blank"
            onClick={() =>
              pushToDataLayer({
                event: 'click_event',
                click_type: 'link',
                click_text: 'go to the lifesum support pages',
                action: undefined,
              })
            }
          >
            {linkText}
          </a>
        </div>
      </div>
    </section>
  )
}

export default Faq
